'use strict';

import React from 'react';

import AppConsole from '@uw-it-sis/lib-react/lib/AppConsole';

import AuditStatus from "../listener/AuditStatus";

const AuditConsole = () => {
    const tabPanels = {
        "audit": {
            title: 'Audit Status',
            component: <AuditStatus />
        },
    }


    return (
        <AppConsole tabPanels={tabPanels} />
    )
}

export default AuditConsole;
